import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faChevronDown } from "@fortawesome/pro-solid-svg-icons";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  SxProps,
  Theme,
  Stack,
} from "@mui/material";
import { MouseEvent, ReactElement, ReactNode } from "react";
import { FaIcon } from "../../DataDisplay/Icon/FaIcon";
import { SrIconButton } from "../Button/SrIconButton";

type SrAccordionProps = {
  label: string;
  children: ReactNode;
  defaultExpanded?: boolean;
  disabled?: boolean;
  sx?: SxProps<Theme>;
  leadingIconButton?: {
    icon: IconDefinition;
    ariaLabel: string;
    onClick?: () => void;
    disabled?: boolean;
  };
};

export const SrAccordion = ({
  label,
  children,
  defaultExpanded = false,
  disabled = false,
  sx,
  leadingIconButton,
}: SrAccordionProps): ReactElement => {
  return (
    <Accordion
      disableGutters
      defaultExpanded={defaultExpanded}
      disabled={disabled}
      elevation={0}
      sx={[
        {
          py: 1,
          pl: 1,
          pr: 2,
          backgroundColor: "surface.main",
          borderRadius: 1,
          "&:before": {
            display: "none",
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <AccordionSummary
        expandIcon={
          <FaIcon
            icon={faChevronDown}
            sx={{
              width: 12,
              height: 12,
              color: "text.primaryAlt",
            }}
          />
        }
        sx={{ typography: "h5" }}
      >
        <Stack component="span" direction="row" alignItems="center">
          {leadingIconButton ? (
            <SrIconButton
              aria-label={leadingIconButton.ariaLabel}
              disabled={disabled || leadingIconButton.disabled}
              size="small"
              sx={{
                position: "absolute",
                left: 0,
              }}
              onClick={(event: MouseEvent<HTMLButtonElement>) => {
                event.preventDefault();
                event.stopPropagation();
                leadingIconButton.onClick?.();
              }}
            >
              <FaIcon icon={leadingIconButton.icon} sx={{ width: 12, height: 12 }} />
            </SrIconButton>
          ) : null}
          <span style={{ marginLeft: leadingIconButton ? "20px" : 0 }}>{label}</span>
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{ pt: 0 }}>{children}</AccordionDetails>
    </Accordion>
  );
};
